
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><g clip-path='url(#clip0_11:1194)'><path d='M10.06 4.99997H5.82L6.48 1.81997C6.56 1.44997 6.44 1.06997 6.18 0.799971C5.74 0.359971 5.03 0.359971 4.6 0.799971L0.6 4.79997C0.21 5.16997 0 5.67997 0 6.20997V12C0 13.1 0.9 14 2 14H7.92C8.72 14 9.44 13.52 9.76 12.79L11.9 7.78997C12.46 6.46997 11.49 4.99997 10.06 4.99997ZM22 9.99997H16.08C15.28 9.99997 14.56 10.48 14.24 11.21L12.1 16.21C11.54 17.53 12.5 19 13.94 19H18.18L17.52 22.18C17.44 22.55 17.56 22.93 17.82 23.2C18.26 23.64 18.97 23.64 19.4 23.2L23.4 19.2C23.78 18.82 23.99 18.32 23.99 17.79V12C24 10.9 23.1 9.99997 22 9.99997Z' fill='#323232'/></g><defs><clipPath id='clip0_11:1194'><rect width='24' height='24' fill='white'/></clipPath></defs></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-thumbs-up-down`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconThumbsUpDown

    ```js
    <b-new-b-icon-thumbs-up-down />
    ```
</docs>


